/* Towlivesmatter product page (2026-10 v2).
   Gallery, option pickers, add to cart, mobile sticky bar, size guide, recommendations.
   The form stays Shopify's native product form; this keeps name="id" in sync.
   Add to cart: the theme's own cart drawer handles [data-product-atc] when it is
   switched on (Theme settings > Cart > ajax). Otherwise we add with /cart/add.js
   (loading state + inline errors) and then open the cart page, as before. */
(() => {
  const root = document.querySelector('[data-tlm-pdp]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => [...el.querySelectorAll(sel)];
  const data = JSON.parse($('[data-product-json]').textContent);
  const form = $('[data-tlm-form]');
  const idInput = $('[data-variant-id]');
  const atc = $('[data-atc]');
  const atcLabel = $('[data-atc-label]');
  const errorEl = $('[data-error]');
  const now = $('[data-now]');
  const was = $('[data-was]');
  const wasAmount = $('[data-was-amount]');
  const groups = $$('[data-option]');
  const sticky = $('[data-sticky]');

  /* ---------------- Gallery ---------------- */
  const stage = $('[data-stage]');
  const slides = stage ? [...stage.children] : [];
  const thumbs = $$('[data-thumb]');
  let index = 0;
  const setActive = (i) => {
    index = i;
    thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.toggleAttribute('aria-current', k === i); });
    const prev = $('[data-nav="-1"]'); const next = $('[data-nav="1"]');
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
    // Keep the active thumbnail visible in the row without moving the page.
    const active = thumbs[i];
    const strip = active && active.parentElement;
    if (strip && strip.scrollWidth > strip.clientWidth + 4) {
      strip.scrollTo({ left: active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
  };
  const goTo = (i, smooth = true) => {
    if (!stage || !slides[i]) return;
    stage.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    setActive(i);
    slides.forEach((s, k) => { if (k !== i) s.querySelector('video')?.pause(); });
  };
  thumbs.forEach((t, k) => t.addEventListener('click', () => goTo(k)));
  $$('[data-nav]').forEach((b) => b.addEventListener('click', () => goTo(Math.max(0, Math.min(slides.length - 1, index + +b.dataset.nav)))));
  if (stage) {
    let tm;
    stage.addEventListener('scroll', () => {
      clearTimeout(tm);
      tm = setTimeout(() => setActive(Math.round(stage.scrollLeft / stage.clientWidth)), 60);
    }, { passive: true });
    stage.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, index + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, index - 1)); }
    });
    setActive(0);
  }
  const showMedia = (id) => {
    const i = slides.findIndex((s) => s.dataset.mediaId === String(id));
    if (i > -1) goTo(i);
  };

  /* ---------------- Dialogs (zoom + size guide) ---------------- */
  const openDialog = (dlg, opener) => {
    if (!dlg) return;
    dlg._opener = opener || document.activeElement;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.classList.add('tlm-locked');
  };
  const closeDialog = (dlg) => { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); };
  $$('dialog').forEach((dlg) => {
    dlg.addEventListener('click', (e) => { if (e.target === dlg) closeDialog(dlg); });
    dlg.addEventListener('close', () => {
      document.documentElement.classList.remove('tlm-locked');
      dlg._opener?.focus?.();
    });
    $$('[data-dialog-close]', dlg).forEach((b) => b.addEventListener('click', () => closeDialog(dlg)));
  });
  const zoom = $('[data-zoom-dialog]');
  $$('[data-zoom]').forEach((b) => b.addEventListener('click', () => {
    const img = $('[data-zoom-img]', zoom);
    img.src = b.dataset.zoom;
    img.alt = b.querySelector('img')?.alt || '';
    openDialog(zoom, b);
  }));
  const sizeDialog = $('[data-size-dialog]');
  document.querySelectorAll('[data-size-open]').forEach((b) => {
    if (!sizeDialog) { b.hidden = true; return; }
    b.addEventListener('click', () => { syncSizeCharts(); openDialog(sizeDialog, b); });
  });

  /* ---------------- Size charts (dialog + "Fit & sizing") ---------------- */
  const charts = [...document.querySelectorAll('[data-sz]')];
  const matchesStyle = (tokens, style) => {
    if (!style) return false;
    const v = style.toLowerCase();
    return tokens.split('|').some((t) => t && v.startsWith(t.toLowerCase()));
  };
  const showPanel = (chart, panel) => {
    const panels = [...chart.querySelectorAll('[data-sz-panel]')];
    panels.forEach((p) => { p.hidden = p !== panel; });
    chart.querySelectorAll('[data-sz-tab]').forEach((t, k) => {
      const on = panels[k] === panel;
      t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
    });
  };
  charts.forEach((chart) => {
    const tabs = [...chart.querySelectorAll('[data-sz-tab]')];
    const panels = [...chart.querySelectorAll('[data-sz-panel]')];
    tabs.forEach((t, k) => {
      t.addEventListener('click', () => showPanel(chart, panels[k]));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        const n = (k + d + tabs.length) % tabs.length;
        showPanel(chart, panels[n]); tabs[n].focus();
      });
    });
    chart.querySelectorAll('[data-sz-unit]').forEach((b) => b.addEventListener('click', () => {
      const cm = b.dataset.szUnit === 'cm';
      document.querySelectorAll('[data-sz]').forEach((c) => {
        c.classList.toggle('is-cm', cm);
        c.querySelectorAll('[data-sz-unit]').forEach((x) => x.setAttribute('aria-pressed', x.dataset.szUnit === b.dataset.szUnit));
      });
    }));
  });
  function syncSizeCharts() {
    const sel = selected();
    const style = data.styleIndex > -1 ? sel[data.styleIndex] : null;
    const size = data.sizeIndex > -1 ? sel[data.sizeIndex] : null;
    charts.forEach((chart) => {
      const panels = [...chart.querySelectorAll('[data-sz-panel]')];
      const panel = panels.find((p) => matchesStyle(p.dataset.szPanel, style));
      if (panel) showPanel(chart, panel);
      chart.querySelectorAll('tr[data-size]').forEach((tr) => tr.classList.toggle('is-current', tr.dataset.size === size));
    });
    const label = document.querySelector('[data-fit-group]');
    const fitChart = label && label.closest('.tlm-pdd__fit')?.querySelector('[data-sz]');
    const visible = fitChart && [...fitChart.querySelectorAll('[data-sz-panel]')].find((p) => !p.hidden);
    if (label && visible && style) label.textContent = style.split(' - ')[0];
  }

  /* ---------------- Variants ---------------- */
  const selected = () => groups.map((g) => (g.querySelector('input:checked') || {}).value);
  const find = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
  const labelFor = (inp) => root.querySelector(`label[for="${inp.id}"]`);

  // When a choice makes later options impossible, keep the same value if it
  // exists for the new combination, else the first available one.
  const repair = (changed) => {
    const sel = selected();
    for (let i = changed + 1; i < groups.length; i++) {
      const fits = (val, needAvail) => data.variants.some((v) =>
        v.options[i] === val && (!needAvail || v.available) && v.options.slice(0, i).every((o, k) => o === sel[k]));
      if (fits(sel[i], false)) continue;
      const inputs = [...groups[i].querySelectorAll('input')];
      const pick = inputs.find((inp) => fits(inp.value, true)) || inputs.find((inp) => fits(inp.value, false));
      if (pick) { pick.checked = true; sel[i] = pick.value; }
    }
  };

  // A value is offered when some variant matches the options chosen before it
  // (later options are free), and available when one of those is in stock.
  const refresh = () => {
    const sel = selected();
    groups.forEach((g, i) => {
      g.querySelectorAll('input').forEach((inp) => {
        const lab = labelFor(inp);
        if (!lab) return;
        const pool = data.variants.filter((v) => v.options[i] === inp.value && v.options.slice(0, i).every((o, k) => o === sel[k]));
        const missing = !pool.length && i > 0;
        lab.classList.toggle('is-missing', missing);
        inp.disabled = missing;
        inp.hidden = missing;
        lab.classList.toggle('is-soldout', !pool.some((v) => v.available));
      });
    });
  };

  const setAtc = (state) => {
    atc.disabled = state !== 'add';
    atcLabel.textContent = state === 'add' ? 'Add to cart' : state === 'soldout' ? 'Sold out' : 'Unavailable';
    if (sticky) {
      $('[data-sticky-label]').textContent = state === 'add' ? 'Add to cart' : state === 'soldout' ? 'Sold out' : 'Choose options';
    }
  };

  const update = (changed = -1) => {
    if (changed > -1) repair(changed);
    refresh();
    const v = find(selected());
    errorEl.hidden = true;
    if (!v) { setAtc('none'); return; }
    idInput.value = v.id;
    now.textContent = v.price;
    if (v.compare) { was.hidden = false; wasAmount.textContent = v.compare; } else { was.hidden = true; }
    setAtc(v.available ? 'add' : 'soldout');
    if (sticky) {
      $('[data-sticky-price]').textContent = v.price;
      $('[data-sticky-variant]').textContent = v.options.map((o) => o.split(' - ')[0]).join(' / ');
    }
    if (v.media && changed > -1) showMedia(v.media);
    syncSizeCharts();
    const url = new URL(location.href); url.searchParams.set('variant', v.id);
    history.replaceState(history.state, '', url);
  };
  groups.forEach((g, i) => g.addEventListener('change', () => update(i)));
  if (groups.length) { refresh(); syncSizeCharts(); }

  /* ---------------- Add to cart ---------------- */
  const drawerOn = () => root.dataset.cartAction === 'ajax' && document.querySelector('[data-cart-drawer]');
  const busy = (on) => { atc.classList.toggle('is-loading', on); atc.setAttribute('aria-busy', on); };
  // The theme drawer flags loading on the button itself; mirror it for screen readers.
  new MutationObserver(() => atc.setAttribute('aria-busy', atc.classList.contains('cart-drawer--loading'))).observe(atc, { attributes: true, attributeFilter: ['class'] });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (atc.disabled || atc.classList.contains('is-loading')) return;
    busy(true);
    errorEl.hidden = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.description || json.message || 'Could not add this item. Please try again.');
      document.dispatchEvent(new CustomEvent('tlm:cart:added', { detail: json }));
      window.location.href = root.dataset.cartUrl || '/cart';
    } catch (err) {
      errorEl.textContent = err.message;
      errorEl.hidden = false;
      busy(false);
    }
  });

  /* ---------------- Mobile sticky add to cart ---------------- */
  if (sticky) {
    // Position check on scroll (rAF-throttled): an IntersectionObserver misses
    // jumps that skip straight past the button, e.g. footer -> top.
    const footer = document.querySelector('.site-footer, footer');
    let raf = 0;
    const render = () => {
      raf = 0;
      const pastAtc = atc.getBoundingClientRect().bottom < 0;
      const nearFooter = footer ? footer.getBoundingClientRect().top < innerHeight : false;
      const show = pastAtc && !nearFooter;
      if (show === sticky.classList.contains('is-visible')) return;
      sticky.classList.toggle('is-visible', show);
      sticky.inert = !show;
      document.documentElement.classList.toggle('tlm-sticky-on', show);
    };
    sticky.hidden = false;
    sticky.inert = true;
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(render); }, { passive: true });
    addEventListener('resize', () => { if (!raf) raf = requestAnimationFrame(render); }, { passive: true });
    render();
    $('[data-sticky-atc]').addEventListener('click', () => {
      if (atc.disabled) {
        const target = groups[groups.length - 1] || atc;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      atc.click();
    });
  }

  /* ---------------- "You may also like" (Shopify recommendations) ---------------- */
  const recs = document.querySelector('[data-recs]:not([data-recs-done])');
  if (recs && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(async ([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      try {
        const html = await (await fetch(recs.dataset.recs)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const list = doc.querySelector('[data-recs-list]');
        if (list && list.children.length) recs.querySelector('[data-recs-list]').innerHTML = list.innerHTML;
      } catch (_) { /* keep the fallback products */ }
    }, { rootMargin: '400px 0px' });
    io.observe(recs);
  }
})();
